<app-reports-toolbar></app-reports-toolbar>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>
<div class="container-fluid">

  <form [formGroup]="form" (ngSubmit)="submitForm()" class="px-3">
    <!--  -->
    <div class="row">

      <div class="me">

        <div id="id1">
          Supplier
        </div>

        <div>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select formControlName="supplier" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox [checked]="isAllSelected(form.get('supplier')?.value, dropdownOptionOrderSupp)"
                  [indeterminate]="isIndeterminate(form.get('supplier')?.value, dropdownOptionOrderSupp)"
                  (change)="toggleSelectAll('supplier', $event, dropdownOptionOrderSupp)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="orderFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredOrder | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>

        </div>

        <div id="id2">
          NAMC/PDC
        </div>
        <div>


          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select formControlName="plant" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox [checked]="isAllSelected(form.get('plant')?.value, dropdownOptionOrderPlant)"
                  [indeterminate]="isIndeterminate(form.get('plant')?.value, dropdownOptionOrderPlant)"
                  (change)="toggleSelectAll('plant', $event, dropdownOptionOrderPlant)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="plantFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredPlant | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div id="id3">
          Logistics Point
        </div>
        <div>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select formControlName="logisticsPoint" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox
                  [checked]="isAllSelected(form.get('logisticsPoint')?.value, dropdownOptionLogisticsPoint)"
                  [indeterminate]="isIndeterminate(form.get('logisticsPoint')?.value, dropdownOptionLogisticsPoint)"
                  (change)="toggleSelectAll('logisticsPoint', $event, dropdownOptionLogisticsPoint)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="logFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredLog | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>


      </div>


    </div>


    <!-- ROW 2 -->

    <div class="row">

      <div class="me">

        <div id="id1">
          Region
        </div>

        <div>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select formControlName="region" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox [checked]="isAllSelected(form.get('region')?.value, dropdownOptionOredrRegion)"
                  [indeterminate]="isIndeterminate(form.get('region')?.value, dropdownOptionOredrRegion)"
                  (change)="toggleSelectAll('region', $event, dropdownOptionOredrRegion)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="orderRegFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredOrderReg | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div id="idTransport">
          Logistics Provider
        </div>
        <div>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select formControlName="transport_Provider" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox [checked]="isAllSelected(form.get('transport_Provider')?.value, dropdownOptionOredrTP)"
                  [indeterminate]="isIndeterminate(form.get('transport_Provider')?.value, dropdownOptionOredrTP)"
                  (change)="toggleSelectAll('transport_Provider', $event, dropdownOptionOredrTP)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="orderTpFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredOrderTp | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div id="id3">
          Status
        </div>
        <div>

          <mat-form-field appearance="outline" class="fixed-select">
            <mat-select formControlName="status" [multiple]="true" [panelWidth]="null">
              <div class="search-all-option">
                <mat-checkbox [checked]="isAllSelected(form.get('status')?.value, dropdownOptionOrderSts)"
                  [indeterminate]="isIndeterminate(form.get('status')?.value, dropdownOptionOrderSts)"
                  (change)="toggleSelectAll('status', $event, dropdownOptionOrderSts)">
                </mat-checkbox>
                <ngx-mat-select-search [formControl]="oderStsFilterCtrl" placeholderLabel="Search"
                  noEntriesFoundLabel="No options found">
                </ngx-mat-select-search>
              </div>
              <div style="max-height: 195px; overflow-y: auto;">
                <mat-option *ngFor="let d of filteredOrderSts | async" [value]="d" style="font-size: 13px;">
                  {{ d.value }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>


      </div>


    </div>


    <!-- ROW 3 -->



    <div class="row">

      <div class="me">

        <div id="id1">
          Start Date<span>*</span>
        </div>

        <div>
          <input type="date" [min]="minDate" [max]="yesterday" onkeydown="return false"
            (change)="onDateChangedEnd($event)" class="  form-control" id="start_Date" name="start_Date"
            formControlName="start_Date" />
          <p *ngIf="form.controls['start_Date'].errors?.['required']
                && (form.controls['start_Date'].touched || submitted )">
            Start date Required
          </p>
        </div>

        <div id="id4">
          End Date<span>*</span>
        </div>
        <div>
          <input type="date" [min]="newDate" [max]="maxDate" (change)="onDateChangedStart($event)"
            onkeydown="return false" class="  form-control" id="end_Date" name="end_Date" formControlName="end_Date" />
          <p *ngIf="form.controls['end_Date'].errors?.['required']
                && (form.controls['end_Date'].touched || submitted )">
            End date Required
          </p>
          <p
            *ngIf="form.hasError('invalidDate') && (form.controls['end_Date'].touched || form.controls['end_Date'].dirty) && submitted">
            End Date is invalid
          </p>
        </div>



      </div>


    </div>


    <!-- ROW 4 -->

    <div class="row">

      <div class="me">

        <div id="id1">
          <button type="submit" (click)="submitted=true" class="roboto-bold" id="btn">FETCH REPORT</button>
        </div>

      </div>

    </div>

  </form>


</div>